var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.unpaidTasksAmount)?_c('div',{staticClass:"earnings-container",class:{ heartbeat: _vm.animate },on:{"click":function($event){return _vm.openEarningsDialog()}}},[_c('v-icon',{staticClass:"mr-3",attrs:{"color":"#dcffc2"}},[_vm._v("mdi-cash-multiple")]),_vm._v(" "+_vm._s(_vm.unpaidTasksAmount)+" "),_c('EarningsDialog',{attrs:{"show":_vm.showEarningsDialog,"onClose":() => {
        _vm.showEarningsDialog = false;
      }}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }